import { gql } from '@apollo/client';

export const CASE_FIELD_CONFIGURATION_FIELDS = gql`
  fragment CaseFieldConfigurationFields on CaseFieldConfigurationView {
    photoEnabled
    details {
      fieldKey
      label
      source
      section
      position
      enabled
      locked
      dataType
      isCustom
    }
    summary {
      fieldKey
      label
      source
      section
      position
      enabled
      locked
      dataType
      isCustom
    }
    customFields {
      id
      name
      fieldType
      archived
      ruleType
      sourceKind
      sourceColumn
      sourceGroupId
      sourceGroupName
      sourceAvailable
    }
  }
`;

// The saved configuration already merged with the field catalog, so the pages render one shape.
export const GET_CASE_FIELD_CONFIGURATION = gql`
  query getCaseFieldConfiguration {
    configuration: getCaseFieldConfiguration {
      ...CaseFieldConfigurationFields
    }
  }
  ${CASE_FIELD_CONFIGURATION_FIELDS}
`;

// Selectable sources for a determined field's rule. Monitoring and categorisation groups offer only
// Status and Effective Date; ART Initiation and Regimen offers its real columns.
export const GET_CASE_FIELD_RULE_SOURCES = gql`
  query caseFieldRuleSources {
    sources: caseFieldRuleSources {
      sourceKind
      groupId
      label
      columns {
        key
        label
      }
    }
  }
`;
